export function useTranslation (key: string, params?: Record<string, unknown>): string {
    return params ? useNuxtApp().$i18n.t(key, params) : useNuxtApp().$i18n.t(key)
}
